import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "smartphone",
  "use": "smartphone-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"smartphone\"><path d=\"M34 4H14a4 4 0 00-4 4v32a4 4 0 004 4h20a4 4 0 004-4V8a4 4 0 00-4-4z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><circle cx=\"24\" cy=\"35\" r=\"1\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/smartphone.svg
// module id = ZJwG
// module chunks = 39 44